import {
  START_REQUEST,
  FINISH_REQUEST,
  SET_NOT_ABROAD,
  SET_ABROAD,
  SET_NOT_ACCIDENTABROAD,
  SET_ACCIDENTABROAD,
  SET_INDEX_BANNER,
  SET_CAR_OPTION_BRAND,
  SET_CAR_OPTION_CARSTYLE,
  SET_MOTOR_OPTION_BRAND,
  SET_MOTOR_OPTION_CARSTYLE,
  SET_CAR_OPTION_CARTYPE,
  SET_MOTOR_OPTION_CARTYPE,
  
} from './constants';

const finishRequest = (state) => {
  state.loading = false;
};

const startRequest = (state) => {
  state.loading = true;
};

/** Begin TravelArea **/
const setNotAbroad = (state, payload) => {
  const {abroad,result } = payload;
  state.travelArea.abroad = abroad;
  state.travelArea.notAbroadOption = result

};
const setAbroad = (state, payload) => {
  const {abroad,result } = payload;
  state.travelArea.abroad = abroad;
  state.travelArea.abroadOption = result;
};

const setNotAccidentAbroad = (state, payload) => {
  //const {abroad,result } = payload;
  const { result } = payload;
  //state.travelArea.abroad = abroad;
  state.accidentArea.notaccidentAbroadOption = result;
  //console.log("not-result:"+JSON.stringify(result));
};

const setAccidentAbroad = (state, payload) => {
  //const {abroad,result } = payload;
  const { result } = payload;
  //state.travelArea.abroad = abroad;
  state.accidentArea.accidentAbroadOption = result;
  //console.log("result:"+JSON.stringify(result));
};

const setIndexBanner = (state, payload) => {
  const { banners } = payload;
  //console.log("setIndexBanner_result:"+JSON.stringify(result.banners));
  //console.log("setIndexBanner_result1:"+JSON.stringify(banners));
  //console.log("setIndexBanner_result2:"+JSON.stringify(payload));
  state.indexBanner = banners;
   
}
const setCarOptionCarType = (state, payload) => {
  state.vehicleOption.carOption.carType = payload;
}
const setMotorOptionCarType = (state, payload) => {
  state.vehicleOption.motorOption.carType = payload;
}
const setCarOptionBrand = (state, payload) => {
  state.vehicleOption.carOption.brand = payload;
}
const setCarOptionCarStyle = (state, payload) => {
  let { carStyle } = payload
  if(!carStyle) {
    carStyle = [];
  }
  state.vehicleOption.carOption.carStyle = carStyle;
}
const setMotorOptionBrand = (state, payload) => {
  state.vehicleOption.motorOption.brand = payload;
}
const setMotorOptionCarStyle = (state, payload) => {
  let { carStyle } = payload
  if(!carStyle) {
    carStyle = [];
  }
  state.vehicleOption.motorOption.carStyle = carStyle;
}
/** End TravelArea **/


export default {
  [START_REQUEST]: startRequest,
  [FINISH_REQUEST]: finishRequest,
  [SET_NOT_ABROAD]: setNotAbroad,
  [SET_ABROAD]: setAbroad,
  [SET_ACCIDENTABROAD]:setAccidentAbroad,
  [SET_NOT_ACCIDENTABROAD]:setNotAccidentAbroad,
  [SET_INDEX_BANNER]: setIndexBanner,
  [SET_CAR_OPTION_CARTYPE]:setCarOptionCarType,
  [SET_CAR_OPTION_BRAND]: setCarOptionBrand,
  [SET_CAR_OPTION_CARSTYLE]: setCarOptionCarStyle,
  [SET_MOTOR_OPTION_CARTYPE]:setMotorOptionCarType,
  [SET_MOTOR_OPTION_BRAND]: setMotorOptionBrand,
  [SET_MOTOR_OPTION_CARSTYLE]: setMotorOptionCarStyle,
};